import * as React from 'react';
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import Modal, { Props as ModalProps } from '../../../Modal';
import Input from '../../../Input';
import Button from '../../../Button/Button';
import { useTheme } from '../../../theme';
import { useRetrieveBookingValidation } from '../../hooks';

export interface Props {
	searchParams: object;
	onSubmit: (values: object) => Promise<boolean>;
}

const ClarifyDocumentModal: React.FC<Props & ModalProps> = ({ onSubmit, searchParams, ...props }) => {
	const { t } = useTranslation('RetrieveBooking');
	const { ClarifyDocumentModal: css } = useTheme('RetrieveBooking');
	const [isLoading, setIsLoading] = useState(false);
	const [ticketIsWrong, setTicketIsWrong] = useState(false);

	const { ticketNumberValidation, ticketNumberFormat } = useRetrieveBookingValidation();

	const handleSubmit = async ({ extraSecret }: { extraSecret: string }) => {
		setTicketIsWrong(false);
		setIsLoading(true);

		const result = await onSubmit({ ...searchParams, extraSecret });

		if (result) {
			props.onClose();
		} else {
			setTicketIsWrong(true);
		}

		setIsLoading(false);
	};

	return (
		<Modal {...props} maxWidth="sm">
			<div className={css.content}>
				<h4 className={css.header}>{t('Enter ticket number')}</h4>

				<p className={css.message}>
					{t('Please enter ticket number for passenger you would like to check-in')}.
				</p>

				<Form onSubmit={handleSubmit}>
					{({ handleSubmit }) => (
						<form onSubmit={handleSubmit} className={css.form}>
							<Field
								format={ticketNumberFormat}
								name="extraSecret"
								validate={(value: string): string | void => {
									if (!value) {
										return t('Required field') as string;
									}

									return ticketNumberValidation(value);
								}}
								render={({ input, meta }) => (
									<Input
										disabled={isLoading}
										absoluteHintPosition={true}
										label={t('Ticket number')}
										TextFieldProps={{
											...input,
											helperText:
												(ticketIsWrong && t('Passenger not found')) ||
												(((meta.modified && meta.touched) || meta.submitFailed) &&
													(meta.error || meta.submitError)),
											error:
												ticketIsWrong ||
												(((meta.modified && meta.touched) || meta.submitFailed) &&
													(!!meta.error || !!meta.submitError))
										}}
									/>
								)}
							/>

							<Button type="submit" isLoading={isLoading} className={css.submit}>
								{t('Open')}
							</Button>
						</form>
					)}
				</Form>
			</div>
		</Modal>
	);
};

export default ClarifyDocumentModal;
